import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BUSINESS } from '../data/i18n';
export function WhatsAppFloat() {
  const {
    t
  } = useLanguage();
  return <a href={BUSINESS.whatsappHref} target="_blank" rel="noopener noreferrer" aria-label={t('wa.tooltip')} className="group fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-whats-500 px-4 py-4 text-white shadow-lift transition-[background-color,transform] duration-200 ease-smooth hover:bg-whats-600 active:scale-95 sm:bottom-6 sm:right-6" data-id="element-319" data-mp="29w3uk9ry6imq">
      <MessageCircleIcon className="h-6 w-6" strokeWidth={2.2} aria-hidden="true" data-id="element-320" data-mp="2ssvl949tk00t" />
      <span className="hidden font-display text-sm font-bold sm:inline" data-id="element-321" data-mp="2nvvdmoxbmp7l">{t('wa.float')}</span>
    </a>;
}